"use strict";

exports.__esModule = true;
exports.default = useQueryBase;

var _react = require("react");

var _useClient = _interopRequireDefault(require("./useClient"));

var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));

var _queryCache = require("./queryCache");

var _getHelpers = _interopRequireDefault(require("./getHelpers"));

var _handleError = _interopRequireDefault(require("./handleError"));

var _getResultPromise = _interopRequireDefault(require("./getResultPromise"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function useQueryBase(options) {
  var client = (0, _useClient.default)(options.clientName);
  var observableQuery = options.omit ? null : (0, _queryCache.getCachedObservableQuery)(client, options);
  var resultRef = (0, _react.useRef)(null);
  var optionsRef = (0, _react.useRef)(options);
  var forceUpdate = (0, _react.useReducer)(function (x) {
    return x + 1;
  }, 0)[1];
  var result = options.omit ? null : observableQuery.currentResult();
  (0, _react.useEffect)(function () {
    if (options.omit) return;
    var subscription = observableQuery.subscribe(function (nextResult) {
      if (!resultRef.current || !(0, _reactFastCompare.default)(resultRef.current.data, nextResult.data) || resultRef.current.networkStatus !== nextResult.networkStatus) {
        forceUpdate();
      }
    });
    return function () {
      subscription.unsubscribe();
      (0, _queryCache.invalidateCachedObservableQuery)(client, options);
    };
  }, [(0, _queryCache.getCacheKey)(options)]);
  if (options.omit) return {};

  if (!(0, _reactFastCompare.default)(optionsRef.current, options)) {
    observableQuery.setOptions(options);
  }

  if (!options.partial && result.partial && options.fetchPolicy !== 'cache-only') {
    var promise = (0, _getResultPromise.default)(observableQuery);
    throw promise;
  }

  resultRef.current = result;

  if (result.errors && result.errors.length) {
    if (options.handleError) {
      options.handleError(result, options);
    } else {
      (0, _handleError.default)(result, options);
    }
  }

  var helpers = (0, _getHelpers.default)(observableQuery);
  return _extends({
    observableQuery: observableQuery
  }, result, helpers);
}